function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("ellipse", {
  cx: 12.6,
  cy: 6.204,
  fill: "#1AB6FF",
  rx: 6.067,
  ry: 6.006
}), React.createElement("path", {
  fill: "#1AB6FF",
  d: "M28.2 20.658c-1 .132-3.6.198-4.867-.396-.733-.33-1.533-2.244-1.866-3.036-.2-.396-.334-.792-.467-.99-.6-1.122-1.8-2.442-4.333-2.442H8.933c-2 0-3.533.99-4.6 2.904l-.2.462c-1 1.848-2.066 3.828-2.466 5.28-.4 1.518-1.267 5.874-1.334 6.072-.266 1.254.6 2.442 1.867 2.706.133 0 .333.066.467.066 1.066 0 2.066-.792 2.266-1.848 0-.066.867-4.356 1.267-5.808.133-.528.533-1.386.933-2.244L6.8 31.416c0 .792.667 1.518 1.467 1.518h8.6c.8 0 1.466-.66 1.466-1.518L18 21.12c.733 1.32 1.733 2.772 3.267 3.432 2.866 1.32 7 .792 7.466.792 1.267-.198 2.2-1.32 2-2.574-.066-1.386-1.2-2.244-2.533-2.112z"
}), React.createElement("ellipse", {
  cx: 51.4,
  cy: 6.204,
  fill: "#7BD5FF",
  rx: 6.067,
  ry: 6.006
}), React.createElement("path", {
  fill: "#7BD5FF",
  d: "M62.333 22.374c-.4-1.452-1.4-3.432-2.466-5.28l-.267-.462c-1.067-1.914-2.6-2.904-4.6-2.904h-7.667c-2.533 0-3.733 1.32-4.333 2.442-.133.264-.267.594-.467.99-.333.792-1.133 2.706-1.866 3.036-1.334.594-3.867.528-4.867.396-1.267-.132-2.467.726-2.6 1.98-.2 1.254.733 2.442 2 2.574.467.066 4.6.594 7.467-.792 1.533-.726 2.6-2.112 3.266-3.432L45.6 31.218c0 .792.667 1.518 1.467 1.518h8.6c.8 0 1.466-.66 1.466-1.518L56.8 21.186c.4.858.8 1.716.933 2.244.4 1.386 1.267 5.742 1.267 5.808.2 1.122 1.2 1.848 2.267 1.848.133 0 .333 0 .466-.066a2.368 2.368 0 001.867-2.706c0-.066-.867-4.356-1.267-5.94z"
}), React.createElement("path", {
  fill: "#7AD5FF",
  d: "M25.733 16.632l.6-.726c.4-.462.934-.66 1.534-.66h6.266l-.4 2.046c-.133.528.467.924.934.594L40 13.992c.333-.264.333-.726 0-.924l-5.333-3.894c-.4-.33-1 .066-.934.594l.4 2.046h-6.4c-1.666 0-3 1.32-3 2.97v1.584c0 .462.667.66 1 .264z"
}));

var SvgInviteFriend = function SvgInviteFriend(props) {
  return React.createElement("svg", _extends({
    width: 64,
    height: 33,
    viewBox: "0 0 64 33"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/invite-friend.72f94a27.svg";
export { SvgInviteFriend as ReactComponent };